<div class="d-flex justify-content-between mb-2 pl-3 pt-2" style="background-color: #fafafa; margin: -20px">
    <h3 class="font-weight-bold mb-3 m-0 pt-1">{{'Confirmation panel' | translate}}</h3>
    <mat-icon (click)="onCloseDialog()" class="cursor mr-2 mt-0">close</mat-icon>
</div>
<div mat-dialog-content>
    <div style="line-height:30px;" class="p-4 mb-0 text-center"> {{'approve-unsubscribe' | translate}}</div>
    <div style="line-height:30px;" class="p-2 mb-0">
        <div class="form-group">
            <label>{{'Comments'|translate}}*</label>
            <div class="input-icon">
                <textarea class="form-control" required autofocus #commentsModel="ngModel" [(ngModel)]="comments" [ngModelOptions]="{standalone: true}" maxlength="400"></textarea>
            </div>
        </div>
        <div *ngIf="submitted && commentsModel.errors" class="invalid-feedback">
            <div *ngIf="commentsModel.errors.required">
                Field is required
            </div>
        </div>
    </div>
</div>
<div mat-dialog-actions class="d-flex mb-2 justify-content-center">
    <button (click)="onCloseDialog()" mat-raised-button type="submit" color="accent" class="card-header-action mr-3">{{'Cancel'|translate}}</button>
    <button (click)="onDelete($event)" mat-raised-button type="submit" color="primary" class="card-header-action mr-3">{{'Approve'|translate}}</button>

</div>